import {
  createFilterFormStore,
  usePersistedFilterFormik,
} from "../../../util/usePersistedFilterFormik";
import { useEffect } from "react";
import { convertToFilter, makeObservable } from "../../../util";
import { createSearchResultNavigationStore } from "../../../util/searchResultNavigation";
import { withExactInstanceReference } from "./ArtworkSearch/utils";

// observable store
const artworkFilterStore = makeObservable({});
const artworkNavigationStore =
  createSearchResultNavigationStore(artworkFilterStore);

const toArtworkFilter = values =>
  convertToFilter({
    values,
    filterKeys: ["tab"],
    skipKeys: ["limit", "offset"],
  });

const filterFormStore = createFilterFormStore(
  "artworks",
  artworkFilterStore,
  artworkNavigationStore,
  // The search form submits Instance Reference as an exact match.
  { toFilter: values => withExactInstanceReference(toArtworkFilter(values)) },
);

const useArtworkFilters = () => {
  const formik = usePersistedFilterFormik(
    {
      initialValues: {
        limit: 50,
        medium: { operator: "like" },
        offset: 0,
        tab: "instance",
        _artworkCategory: { id: { operator: "in" } },
        _edition: { year: { operator: "eq" } },
      },
    },
    filterFormStore,
  );

  useEffect(() => {
    // convert formik values to filter and update store
    artworkFilterStore.set(toArtworkFilter(formik.values));
  }, [formik.values]);

  return {
    formik,
  };
};

export { artworkFilterStore, artworkNavigationStore, useArtworkFilters };
